import {Table, Form, Space, Radio, Badge, Flex } from 'antd'
import React, { useEffect, useState } from 'react'
import CostCheck from './CostCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './cost.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import CostEditReportEdit from './CostEditReportEdit';
import CostEdit from './CostEdit';
function CostListSubmitted(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "ddzc_state": '',     
  });
    useEffect(() => {
        if (props.list) {
            let arr = props.list.filter((item) => ((item.ddzc_state === '2' || item.ddzc_state === '3' || item.ddzc_state === '4' || item.ddzc_state === '5' || item.ddzc_state === '6') && item.ddzc_uid === props.yh_id) && item.ddzc_uid === props.yh_id);      
            if(query.ddzc_state){
                if(query.ddzc_state === '5'){
                  arr = arr.filter((item) => item.ddzc_state === '5' || item.ddzc_state === '6');
                }else{
                  arr = arr.filter((item) => item.ddzc_state === query.ddzc_state);
                }
            }      
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.ddzc_id
            }));
            const unread = arr.filter(item => item.ddzc_state === '5');
            const read = arr.filter(item => item.ddzc_state === '2' || item.ddzc_state === '3' || item.ddzc_state === '4' ||  item.ddzc_state === '6');
            read.sort((a, b) => new Date(b.ddzc_state_time) - new Date(a.ddzc_state_time));
            const sortedArr = [...unread, ...read];
            setList(sortedArr);
        }
    }, [props.list, query.ddzc_state, props.yh_id])
    
    const columns = [    
        {
            title: '付款客户',
            dataIndex: 'ddzc_kh_name',
            width: '12%',
            key: 'ddzc_kh_name',         
            render: (text, record) =>{
                if(record.ddzc_state === '4'){
                    if(record.ddzc_bzd_id){
                        return <CostEditReportEdit
                            ddzc_id={record.key} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            ddzc_bzd_id={record.ddzc_bzd_id}
                            ddzc_bzd_name={record.ddzc_bzd_name}
                            ddzc_kh_id={record.ddzc_kh_id}
                            ddzc_kh_name={record.ddzc_kh_name}
                            ddzc_state={record.ddzc_state}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                        />
                    }else{
                        return <CostEdit
                            ddzc_id={record.key} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            ddzc_bzd_id={record.ddzc_bzd_id}
                            ddzc_bzd_name={record.ddzc_bzd_name}
                            ddzc_kh_id={record.ddzc_kh_id}
                            ddzc_kh_name={record.ddzc_kh_name}
                            ddzc_state={record.ddzc_state}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                        />
                    }
                   
                }else{
                    return <CostCheck
                                        type='button'
                                        ddzc_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        ddzc_bzd_id={record.ddzc_bzd_id}
                                        ddzc_price={record.ddzc_price}
                                        ddzc_content={record.ddzc_content}
                                        ddzc_date={record.ddzc_date}
                                        ddzc_date_end={record.ddzc_date_end}
                                        ddzc_bzd_name={record.ddzc_bzd_name}
                                        ddzc_bzd_danhao={record.ddzc_bzd_danhao}
                                        ddzc_type_id={record.ddzc_type_id}
                                        ddzc_type_name={record.ddzc_type_name}
                                        ddzc_kh_id={record.ddzc_kh_id}
                                        ddzc_kh_name={record.ddzc_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        ddzc_num={record.ddzc_num}
                                        ddzc_amount={record.ddzc_amount}
                                        ddzc_state={record.ddzc_state}
                                        ddzc_bm_id={record.ddzc_bm_id}
                                        ddzc_bm_name={record.ddzc_bm_name}
                                        ddzc_khyhzh_id={record.ddzc_khyhzh_id}
                                        ddzc_khyhzh_name={record.ddzc_khyhzh_name}
                                        ddzc_image_name={record.ddzc_image_name}
                                        ddzc_image_file={record.ddzc_image_file}
                                        ddzc_ctime={record.ddzc_ctime}
                                        ddzc_uid={record.ddzc_uid}
                                        listType='submitted'
                                    />
                                }
                            }
        },
      
        {
            title: '付款金额',
            dataIndex: 'ddzc_amount',
            width: '10%',
            key: 'ddzc_amount',   
            render: (text, record) => <span style={{color:'green'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'ddzc_content',
            key:'ddzc_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"ddzc_bzd_danhao",
            key:'ddzc_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.ddzc_bzd_name} dsbzd_id={record.ddzc_bzd_id} dsbzd_danhao={record.ddzc_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },      
        {
            title: '审批时间',
            dataIndex: 'ddzc_state_time',
            width: '10%',
            key: 'ddzc_state_time',             
        },
        {
            title: '状态',
            dataIndex: 'ddzc_state',
            width: '5%',
            key: 'ddzc_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_cost_list_submitted'
                    form={form}
                    initialValues={{                        
                        ddzc_state: query.ddzc_state ? query.ddzc_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            dsbzd_state: values.dsbzd_state ? values.dsbzd_state : '',
                            dsbzd_kh_id: values.dsbzd_kh_id ? values.dsbzd_kh_id : '',
                            dsbzd_content: values.dsbzd_content ? values.dsbzd_content : '',
                        };
                        
                        localStorage.setItem('jtg-caiwu_reportList_dsbzd_state', JSON.stringify(serializedValues.dsbzd_state));
                        localStorage.setItem('jtg-caiwu_reportList_dsbzd_kh_id', JSON.stringify(serializedValues.dsbzd_kh_id));
                        localStorage.setItem('jtg-caiwu_reportList_dsbzd_content', JSON.stringify(serializedValues.dsbzd_content));
                        setQuery(prev => ({ 
                            ...prev, 
                            dsbzd_state: serializedValues.dsbzd_state, 
                        }));
                    }}
                >
                    <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    ddzc_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_costList_ddzc_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge count={props.ddzcRejectedNum} style={{zIndex:'9999'}}>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Badge count={props.ddzcEndNeedReadNum} style={{zIndex:'9999'}}>
                                <Radio value='5' >已结束</Radio>
                            </Badge>                            
                        </Radio.Group>        
                    </Form.Item>                    
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_costList_ddzc_state', JSON.stringify(''))
                                    setQuery({
                                        "ddzc_state": '',                                        
                                    })
                                    form.setFieldsValue({
                                        ddzc_content: null,
                                        ddzc_kh_id: null,
                                        ddzc_bzd_danhao: null,
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'green'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无付款数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default CostListSubmitted